import React from 'react'
import {Link} from 'react-router-dom'

export function ReturnButton() {
  let params = window.location.pathname.split('/')
  const coursenum = params[3]
  return (
    <Link
      className="btn btn-myed btn-default btn-default-myed btn-sm-myed rounded border-0 m-1 p-2"
      to={`/instructor/lti_dashboard/${coursenum}`}
    >
      <i className="fa-solid fa-arrow-left m-1"></i>
      <p className="d-inline m-1">Dashboard</p>
    </Link>
  )
}
